// @ts-nocheck
import qs from 'qs';
import { put, takeLatest } from 'redux-saga/effects';
import { postAPIDataV3, getAPIDataV3 } from 'utils/api';
import * as slice from './reducer';
import * as sagaActions from './sagaActions';
import * as constants from './constants';
import { getItemFromLocalStorage, setItemInLocalStorage } from 'utils/storage';
import { triggerNotification } from 'organisms/notifications/sagaActions';
import { REQUESTS } from 'utils/services/thetaretail/requests';
import { getWebAppSettings } from 'models/user/selector';
import { getState } from 'reducers';

function* handleDefaultStoreSchedulesFetch() {
	yield put(
		slice.toggleLoader({
			loaderComponent: constants.LOADER_COMPONENTS.DEFAULT_ORDERS,
			isLoading: true,
		})
	);
	const isView = getWebAppSettings(getState())?.IsAclRowLevelAccessEnabled;

	const { data, isError, error } = yield postAPIDataV3({
		...REQUESTS.POST.GET_AVAILABILITY_INFO,
		body: {
			isView,
		},
	})
		.then((response) => ({
			data: response?.data,
		}))
		.catch((error) => ({ error }));

	if (isError) {
		yield put(
			triggerNotification({ message: 'An error occurred while fetching availability, please try again later' })
		);
		//   return;
	}
	yield put(slice.updateInventoryData({ data: data || {} }));

	yield put(
		slice.toggleLoader({
			loaderComponent: constants.LOADER_COMPONENTS.DEFAULT_ORDERS,
			isLoading: false,
		})
	);
}

function* updateStatusID({ payload }: any) {
	const { statusID } = payload;

	setItemInLocalStorage('statusID', statusID);

	yield put(slice.updateStatusID({ statusID }));
}

function* updateIntervalID({ payload }: any) {
	const { statusIntervalID } = payload;

	yield put(slice.updateIntervalID({ statusIntervalID }));
}

function* loadPage() {
	//   yield put(triggerNotification({info: 'as', type: '1'}))
}

export const checkStatus = async (statusID: any) => {
	const { data } = await getAPIDataV3({
		...REQUESTS.GET.GET_PROCESS_STATUS,
		pathParams: { statusId: statusID },
		queryParams: { refresh: new Date().getTime().toString() },
	});
	return data?.data?.CurrentStatus?.toLowerCase();
};

function* checkOrderStatus({ payload: { statusID } }) {
	if (!statusID) {
		return;
	}
	let status = yield checkStatus(statusID);
	if (status === 'complete') {
		yield updateStatusID({ payload: { statusID: null } });
	}
}

export default function* rootSaga() {
	return [
		yield takeLatest(sagaActions.loadPage, loadPage),
		yield takeLatest(sagaActions.getInventoryData, handleDefaultStoreSchedulesFetch),
		yield takeLatest(sagaActions.updateStatusID, updateStatusID),
		yield takeLatest(sagaActions.updateIntervalID, updateIntervalID),
		yield takeLatest(sagaActions.checkOrderStatus, checkOrderStatus),
	];
}
